// Port of products/chart.coffee:46-55,189-212 and sections/chart.coffee:46-55,324-348,
// parameterized: percentCapableViews = ['amount'] (products) / ['opened', 'purchased'] (sections).
//
// itemsCount: products — NA-filtered answerVariants length (products/chart.coffee:191);
// sections — sections length.

export const getChartModeTypes = ({ viewMode, percentCapableViews, itemsCount }) => {
  if (itemsCount > 12) {
    return percentCapableViews.includes(viewMode) ? ['brespondents', 'bpercents'] : ['brespondents']
  }
  return percentCapableViews.includes(viewMode)
    ? ['respondents', 'percents', 'brespondents', 'bpercents']
    : ['respondents', 'brespondents']
}

export const getDefaultChartMode = ({ chartMode, globalChartMode, viewMode, percentCapableViews, itemsCount }) => {
  let mode = chartMode === 'off' ? globalChartMode : chartMode
  mode = mode || globalChartMode

  const percentCapable = percentCapableViews.includes(viewMode)

  if (itemsCount > 12) {
    if (percentCapable) {
      if (['pie', 'respondents'].includes(mode)) return 'brespondents'
      if (mode === 'percents') return 'bpercents'
      return mode
    }
    return 'brespondents'
  }

  if (percentCapable) return mode === 'pie' ? 'respondents' : mode
  if (['pie', 'percents'].includes(mode)) return 'respondents'
  if (mode === 'bpercents') return 'brespondents'
  return mode
}
